import { post } from './post';

/**
 * API endpoint call for sending a Contact Form
 * <code>
 * const sendContactForm = await sendContactForm(model)
 * </code>
 */
export async function sendContactForm(model, reCaptchToken) {
  return post('/v1/contact', model, reCaptchToken);
}
